interface ITag {
  name: string;
  nameLocal: string;
  value: string;
}

export interface IWidgetTag {
  id: string | number;
  color: string;
  url: string;
}

export const tags: ITag[] = [
  {
    name: 'Combo',
    nameLocal: 'Combo',
    value: 'SUPER_COMBO',
  },
];

export const STATIC_CATEGORY = [
  {
    id: 'ShopByBrand',
    pathname: '/thuong-hieu',
    key: 'shopByBrand',
  },
];

/** Backend "Frozen Goods" category — needs preservation=Frozen on productSearch */
export const FROZEN_FOOD_CATEGORY_ID = 900;

/** Backend "Frozen Goods" — excluded from sidebar nav */
export const HIDDEN_NAV_CATEGORY_IDS = [FROZEN_FOOD_CATEGORY_ID];

export const getNavCategories = <T extends { id?: number | null }>(categories: T[] = []): T[] =>
  categories.filter((category) => category.id == null || !HIDDEN_NAV_CATEGORY_IDS.includes(category.id));

export const WIDGET_TAGS: IWidgetTag[] = [
  {
    id: 'GYOMU_SUPER',
    color: '#D3F1A7',
    url: '',
  },
  {
    id: 'BEST_DEALS',
    color: '#FDD0EC',
    url: '',
  },
  {
    id: 'NEW_PRODUCTS',
    color: '#F8E6A0',
    url: '',
  },
  {
    id: 'BEST_PRICES',
    color: '#C6EDFB',
    url: '',
  },
  {
    id: 'THUONG_HIEU_KAMEREO',
    color: '#D4EDD5',
    url: '',
  },
  {
    id: 'HANG_THUNG_GIA_TOT',
    color: '#FBE5C6',
    url: '',
  },
  {
    id: 'SUPER_SAVING_TAG',
    color: '#C6E7FB',
    url: '',
  },
];

export const ALL_PRODUCTS = 'All';
